import { getInformationWithData } from "../../../services/CABE"
import { getValueCookie } from "../../../services/cookieService"

export class ItemsVendor {

    ItemCode
    ProductLine
    ItemCodeDesc
    ItemURL
    VendorList = []

    constructor(ItemCode, ItemCodeDesc, ProductLine) {
        this.ItemCode = ItemCode
        this.ItemCodeDesc = ItemCodeDesc
        this.ProductLine = ProductLine
        this.TotalQuantity=0
        this.TotalAmt=0
    }

    addVendor(vendor) {
        this.VendorList.push(vendor)
    }

    calculateTotals(){
        this.TotalQuantity=0
        this.TotalAmt=0
        for (const item of this.VendorList) {
          
            if(Number(item.LastReceiptQuantity)){
                this.TotalQuantity+=Number(item.LastReceiptQuantity)
            }
            if(Number(item.TotalPrice)){
                this.TotalAmt+=Number(item.TotalPrice)
            }

        }
    }

    async refreshItemURL() {
        if (this.ItemURL) {
            return this.ItemURL
        } else {
            const data = {
                idCompany: Number(getValueCookie('CompanyId')),
                ItemCode: this.ItemCode
            }
            const result = await getInformationWithData('/Items/get/Img', data)
            if (result.status.code === 1) {
                if (result.data.itemURLImage) {
                    if (result.data.itemURLImage !== '') {
                        const date = new Date().getTime()
                        return `${result.data.itemURLImage}?${date}`
                    }

                }
            }

        }

        return ''
    }


}


export class Vendors {
    VendorNo
    VendorName
    LastReceiptQuantity
    LastUnitCost
    LastReceiptDate
    OrderNo
    TotalPrice
    TotalQuantity
    ItemList = []

    constructor(VendorNo, VendorName, LastReceiptQuantity, LastUnitCost, LastReceiptDate,OrderNo) {
        this.VendorNo = VendorNo
        this.VendorName = VendorName
        this.LastReceiptQuantity = LastReceiptQuantity
        this.LastUnitCost = LastUnitCost
        this.LastReceiptDate = LastReceiptDate
        this.OrderNo=OrderNo
        this.TotalQuantity=0
        this.TotalPrice=(LastReceiptQuantity&&LastUnitCost)?((Number(LastReceiptQuantity)*Number(LastUnitCost))):0
    }
    addItem(item) {
        this.ItemList.push(item)
    }
    calculateTotals(){}
}

export class ItemPerVendor {
    LastReceiptQuantity
    LastUnitCost
    LastReceiptDate
    ItemCode
    ItemCodeDesc
    ProductLine
    ItemURL
    OrderNo
    TotalAmt

    constructor(LastReceiptQuantity, LastUnitCost, LastReceiptDate, ItemCode, ItemCodeDesc, ProductLine,OrderNo) {
        this.LastReceiptQuantity = LastReceiptQuantity
        this.LastUnitCost = LastUnitCost
        this.LastReceiptDate = LastReceiptDate
        this.ItemCode = ItemCode
        this.ItemCodeDesc = ItemCodeDesc
        this.ProductLine = ProductLine
        this.OrderNo=OrderNo
        this.TotalAmt=(Number(LastReceiptQuantity)&&Number(LastUnitCost))?Number(LastReceiptQuantity)*Number(LastUnitCost):0
    }
}

export class VendorDetail {
    VendorNo
    VendorName
    Detail = []

    constructor(VendorNo, VendorName) {
        this.VendorNo = VendorNo
        this.VendorName = VendorName
    }
    addDetailVendor(PurchaseOrderNo, OrderDate, QuantityInvoiced, UnitCost) {
        this.Detail.push(new DetailVendor(PurchaseOrderNo, OrderDate, QuantityInvoiced, UnitCost))
    }
}

export class DetailVendor {
    PurchaseOrderNo
    OrderDate
    QuantityInvoiced
    UnitCost

    constructor(PurchaseOrderNo, OrderDate, QuantityInvoiced, UnitCost) {
        this.PurchaseOrderNo = PurchaseOrderNo
        this.OrderDate = OrderDate
        this.QuantityInvoiced = QuantityInvoiced
        this.UnitCost = UnitCost
    }
}



